import { PayloadAction } from '@reduxjs/toolkit';

import { GalleryState } from 'editor/src/store/gallery/types';

const selectImageReducer = (state: GalleryState, action: PayloadAction<string>) => {
  state.selectedImagesIds.push(action.payload);
};

export default selectImageReducer;
